import React, { useState } from 'react'
import {
  Form,
  Button,
  Container,
  ButtonGroup,
  ToggleButton
} from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'

const SearchBoxPos = () => {
  const [keyword, setKeyword] = useState('')
  const [radioValue, setRadioValue] = useState('1')

  const navigate = useNavigate()

  const submitHandler = (e) => {
    e.preventDefault()
    if (keyword.trim()) {
      let word = keyword
      let radio = radioValue
      let wordradio = word + radio

      navigate(`/searchpos/${wordradio}/*`)
    } else {
      setKeyword('')
      setRadioValue('1')
      navigate('/pos')
    }
  }

  const radios = [
    { name: 'UPC', value: '1' },
    { name: 'Mfg', value: '2' },
    { name: 'Name', value: '3' }
  ]

  return (
    <Container className='search-shell'>
      <Form
        className='d-flex align-items-center gap-2 flex-wrap'
        onSubmit={submitHandler}
      >
        <ButtonGroup className='search-toggle-group'>
          {radios.map((radio, idx) => (
            <ToggleButton
              key={idx}
              id={`radio-${idx}`}
              type='radio'
              variant='outline-secondary'
              size='sm'
              name='radio'
              value={radio.value}
              checked={radioValue === radio.value}
              onChange={(e) => setRadioValue(e.currentTarget.value)}
            >
              {radio.name}
            </ToggleButton>
          ))}
        </ButtonGroup>
        <Button
          type='submit'
          variant='outline-primary'
          size='sm'
          className='search-action-btn'
        >
          Search
        </Button>
        <Form.Control
          type='text'
          name='q'
          onChange={(e) => setKeyword(e.target.value)}
          placeholder='UPC, Mfg, Name'
          className='search-input my-2'
        />
      </Form>
    </Container>
  )
}

export default SearchBoxPos
